var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.643229C3 0.287598 3.26306 0 3.58835 0C3.91363 0 4.17669 0.287598 4.17669 0.643229V1.62354H17.5587C17.802 1.62354 18 1.84001 18 2.10596V12.4347C18 12.7007 17.802 12.9172 17.5587 12.9172H4.17669V18.3568C4.17669 18.7124 3.91363 19 3.58835 19C3.26306 19 3 18.7124 3 18.3568V0.643229ZM14.9395 8.55062H17.1175V5.8339H14.9395V8.55062ZM14.6057 11.9523V8.91553H12.1844V11.9523H14.6057ZM14.6057 5.46899V2.58838H12.1844V5.46899H14.6057ZM9.09561 11.9523V8.91553H6.67292V11.9523H9.09561ZM9.42938 8.55062H11.8507V5.8339H9.42938V8.55062ZM9.09561 5.46899V2.58838H6.67292V5.46899H9.09561ZM6.34056 8.55062V5.8339H4.19225V8.55062H6.34056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacesIcon);
export default __webpack_public_path__ + "static/media/races-icon.a0f0b77dec77430e6d06b1f65e29e0d6.svg";
export { ForwardRef as ReactComponent };